/* lua.js generated code 0.3.0 */

require("clover/const/GamePropConst")
UserPropData = {}
UserPropToTimePropRef = table(
    [1, GamePropIds.kRefresh, table([0, GamePropIds.kRefresh_l])],
    [1, GamePropIds.kLine, table([0, GamePropIds.kLine_l])],
    [1, GamePropIds.kSwap, table([0, GamePropIds.kSwap_l])],
    [1, GamePropIds.kAdd5, table([0, GamePropIds.kAdd5_l])],
    [1, GamePropIds.kWrap, table([0, GamePropIds.kWrap_l])],
    [1, GamePropIds.kHammer, table([0, GamePropIds.kHammer_l])]
)
UserPropToTempPropRef = table(
    [1, GamePropIds.kRefresh, table([0, GamePropIds.kRefresh_t])],
    [1, GamePropIds.kLine, table([0, GamePropIds.kLine_t])],
    [1, GamePropIds.kSwap, table([0, GamePropIds.kSwap_t])],
    [1, GamePropIds.kWrap, table([0, GamePropIds.kWrap_t])],
    [1, GamePropIds.kHammer, table([0, GamePropIds.kHammer_t])]
)
UserPropToInfinitePropRef = table(
    [1, GamePropIds.kLine, table([0, GamePropIds.kLine_i])],
    [1, GamePropIds.kWrap, table([0, GamePropIds.kWrap_i])],
    [1, GamePropIds.kHammer, table([0, GamePropIds.kHammer_i])]
)
UserPropData.isTimeProp = function (propId) {
    var propMeta = MetaManager.getInstance().getPropMeta(propId)
    if (propMeta) {
        return propMeta.expireTime !== 0 || propMeta.fixedExpireTime || propMeta.expireType
    }
    return false
}
UserPropToAdPropRef = table(
    [1, GamePropIds.kRefresh, GamePropIds.kRefresh_ad],
    [1, GamePropIds.kLine_Wrap_b, GamePropIds.kLine_Wrap_ad],
    [1, GamePropIds.kAdd3_b, GamePropIds.kAdd3_ad],
)
UserAdPropToPropRef = (function() {
    let map = {};
    for(let key in UserPropToAdPropRef) {
        map[UserPropToAdPropRef[key]] = tonumber(key);
    }
    return map;
})()
UserPropData.isAdProp = function (propId) {
    return UserAdPropToPropRef[propId] != null
}
UserPropData.isTempProp = function (propId) {
    let self = this
    let propMeta = MetaManager.getInstance().getPropMeta(propId)
    if (propMeta) {
        return propMeta.propMode === 4
    }
    return false
}
//获取当前id是否为无限道具(仅背包)
UserPropData.isBagInfiniteProp = function (propId) {
    if (propId >= 10200 && propId < 10299){
        return true
    }
    if (propId == 10051){
        return true
    }
    return false
    
}
//获取当前id是否为限时道具(仅背包)
UserPropData.isBagTimeLimitProp = function (propId) {
    if (propId >= 10012 && propId < 10017){
        return true
    }
    if (propId == 10038){
        return true
    }
    return false
}
//获取当前id是否为关前道具(仅背包)
UserPropData.isBagPreLevelProp = function (propId) {
    console.log("propId:"+propId)
    if ((propId >= 10200 && propId <= 10214)
        ||(propId >= 10220 && propId <= 10234)
        ||(propId >= 10240 && propId <= 10254))
    {
        return true
    }
    if (propId == 10011 || propId == 10008 || propId == 10009 || propId == 10300 || propId == 10340 || propId == 10320){
        return true
    }
    return false
}
//获取当前id是否为关内道具(仅背包)
UserPropData.isBagInLevelProp = function (propId) {
    if ((propId >= 10001 && propId <= 10006)
        ||(propId >= 10012 && propId <= 10017))
    {
        return true
    }
    return false
    
}
//获取当前id是否为无限前置道具
UserPropData.isInfinitePreProp = function (propId) {
    let self = this
    let propMeta = MetaManager.getInstance().getPropMeta(propId)
    if (propMeta) {
        return propMeta.propMode === 18 || propMeta.propMode === 19 || propMeta.propMode === 20
    }
    return false
}
//获取当前id是否为限时限次前置道具
UserPropData.isLitmitedPreProp = function (propId) {
    let self = this
    let propMeta = MetaManager.getInstance().getPropMeta(propId)
    if (propMeta) {
        return propMeta.propMode === 22 || propMeta.propMode === 23 || propMeta.propMode === 24
    }
    return false
}
//获取当前id是否为限时无限道具
UserPropData.isInfiniteTimeProp = function (propId) {
    let self = this
    let propMeta = MetaManager.getInstance().getPropMeta(propId)
    if (propMeta) {
        return propMeta.propMode === 9 || propMeta.propMode === 10 || propMeta.propMode === 11 || propMeta.propMode === 12
    }
    return false
}
//获取无限前置道具元道具 返回【是否为元道具，元道具id】
UserPropData.getInfiniteMetaPreProp = function (propId) {
    let self = this
    let propMeta = MetaManager.getInstance().getPropMeta(propId)
    for (let k in InfinitePrePropsMap){
        
        let item = InfinitePrePropsMap[k]
        if ($null(item)) continue
        if (propMeta && propMeta.propMode == MetaManager.getInstance().getPropMeta(item).propMode){

            return [item == propId, item]
        }
    }

    return [false, null]
}
//将无限道具转换为普通道具
UserPropData.transformOriPreProp = function (propId) {
    let self = this
    for (let k in InfinitePrePropsMap){
        let item = InfinitePrePropsMap[k]
        if ($null(item)) continue
        if (item == propId){

            return k
        }
    }

    return propId
}
// 无限道具(仅限本关，引导用)
UserPropData.isInfiniteProp = function (propId) {
    let self = this
    let propMeta = MetaManager.getInstance().getPropMeta(propId)
    if (propMeta) {
        return propMeta.propMode === 6
    }
    return false
}
UserPropData.getPermanentPropId = function (propId) {
    for (let k in UserPropToTimePropRef) {
        let v = UserPropToTimePropRef[k]
        k =  isNaN(tonumber(k)) ? 0 : tonumber(k)
        if ($null(v)) continue
        if (k === propId || table.indexof(v, propId)) {
            return k
        }
    }
    for (let k in UserPropToTempPropRef) {
        k =  isNaN(tonumber(k)) ? 0 : tonumber(k)
        let v = UserPropToTempPropRef[k]
        if ($null(v)) continue
        if (k === propId || table.indexof(v, propId)) {
            return k
        }
    }
    for (let k3 in UserPropToInfinitePropRef) {
        k3 =  isNaN(tonumber(k3)) ? 0 : tonumber(k3)
        let v3 = UserPropToInfinitePropRef[k3]
        if ($null(v3)) continue
        if (k3 === propId || table.indexof(v3, propId)) {
            return k3
        }
    }

    let v = tonumber(UserAdPropToPropRef[propId])
    if (!isNaN(v))
        return v;

    return propId
}
// 实物道具
UserPropData.isRealRewardProp = function (propId) {
    let self = this
    let propMeta = MetaManager.getInstance().getPropMeta(propId)
    if (propMeta) {
        return propMeta.propMode === 16
    }
    return false
}
// 是否是装扮类
UserPropData.isDressUp = function (propId) {
    // bp相关的名片和标记还没修改暂时不做装扮处理
//    if (propId == GamePropIds.kNameCard || 
//     propId == GamePropIds.kNameDiamond
//    ){
//      return false
//    }
   return propId >= 90000 && propId <= 99999
}
// 是否是头像框
UserPropData.isHeadFrame = function (propId) {

    let config = DressManager.getInstance().getDressMsg(propId)
    // if (!UserPropData.isDressUp(propId)) return false
    return config && config.type ==  GameDressTypes.kHeadFrame
}

// 各种道具的原始道具id
UserPropData.getBasePropId = function (propId) {
    if (propId === GamePropsType.kHammer || propId === GamePropsType.kHammer_l || propId === GamePropsType.kHammer_t || propId === GamePropsType.kHammer_i || propId === GamePropsType.kHammer_big || propId === GamePropsType.kHammer_Cur_Level || propId === GamePropsType.kHammerMultiHit || propId === GamePropsType.kHammerBigIsland || propId === GamePropsType.kHammerBigIsland_l || propId === GamePropsType.kHammer_bind_level) {
       return GamePropsType.kHammer
    } else if (propId === GamePropsType.kSwap || propId === GamePropsType.kSwap_l || propId === GamePropsType.kSwap_t || propId === GamePropsType.kSwap_Cur_Level) {
        return GamePropsType.kSwap
    } else if (propId === GamePropsType.kLine || propId === GamePropsType.kLine_l || propId === GamePropsType.kLine_t || propId === GamePropsType.kLine_i || propId === GamePropsType.kLine_Activity || propId === GamePropsType.kLine_Infi ){
        return GamePropsType.kLine
    } else if (propId === GamePropsType.kWrap || propId === GamePropsType.kWrap_l || propId === GamePropsType.kWrap_t || propId === GamePropsType.kWrap_i ){
        return GamePropsType.kWrap
    } else if (propId === GamePropsType.kRefresh || propId === GamePropsType.kRefresh_l || propId === GamePropsType.kRefresh_t || propId === GamePropsType.kRefresh_ad ){
        return GamePropsType.kRefresh
    }
}